import { createContext, useContext, useEffect, useState } from 'react';
import vconst from 'utils/helpers/structs/vconst';
import { useAuth } from 'context/AuthContext';
import { safeJSONParse } from 'utils/helpers/safeParsing';
import type { LeadContextValue, LeadProviderProps } from '../types';

const LeadContext = createContext<LeadContextValue | null>(null);
export const useLead = (): LeadContextValue => useContext(LeadContext) as LeadContextValue;

export const defLeadsStatus = [
    vconst.leadNew,
    vconst.leadInWoork,
    vconst.leadNeedOffer,
    vconst.leadNeedsAttention,
    vconst.leadOffer,
];

export const LeadProvider = ({ children }: LeadProviderProps) => {
    const { auth } = useAuth();
    const filterName = `voltox-${auth.user.ID}-leads-filter`;
    const orderName = `voltox-${auth.user.ID}-leads-order`;
    const descName = `voltox-${auth.user.ID}-leads-desc`;

    const [showSpinner, setShowSpinner] = useState(false);
    const [listResetNonce, setListResetNonce] = useState(0);
    const [listRefreshNonce, setListRefreshNonce] = useState(0);
    const [leadsOrder, setLeadsOrder] = useState<string>(safeJSONParse(sessionStorage.getItem(orderName)) || '');
    const [leadsDesc, setLeadsDesc] = useState<boolean>(safeJSONParse(sessionStorage.getItem(descName)) === true);
    const [leadsCheck, setLeadsCheck] = useState<number[]>([]);
    const [leadsSatus, setLeadStatus] = useState<number[]>(
        safeJSONParse(sessionStorage.getItem(filterName)) || defLeadsStatus,
    );

    const triggerListReset = () => setListResetNonce((nonce) => nonce + 1);
    const triggerListRefresh = () => setListRefreshNonce((nonce) => nonce + 1);

    useEffect(() => {
        sessionStorage.setItem(filterName, JSON.stringify(leadsSatus));
    }, [leadsSatus, filterName]);

    useEffect(() => {
        sessionStorage.setItem(orderName, JSON.stringify(leadsOrder));
    }, [leadsOrder, orderName]);

    useEffect(() => {
        sessionStorage.setItem(descName, JSON.stringify(leadsDesc));
    }, [leadsDesc, descName]);

    const values: LeadContextValue = {
        showSpinner,
        setShowSpinner,
        leadsOrder,
        setLeadsOrder,
        leadsDesc,
        setLeadsDesc,
        leadsCheck,
        setLeadsCheck,
        leadsSatus,
        setLeadStatus,
        listResetNonce,
        triggerListReset,
        listRefreshNonce,
        triggerListRefresh,
    };

    return <LeadContext.Provider value={values}>{children}</LeadContext.Provider>;
};
